module.exports = __webpack_public_path__ + "static/img/rank_game_bg.a3caafb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_game_bg.png
// module id = HFK5
// module chunks = 0